// extracted by mini-css-extract-plugin
module.exports = {"landingContainer":"Landinglayout_landingContainer__2sxnw","buttonLink":"Landinglayout_buttonLink__1t0XX","landinglayout":"Landinglayout_landinglayout__3i10X"};